<p class="card-subtitle">
    disposed information text
</p>